module.exports = __webpack_public_path__ + "img/code-no-bulk-img.338c8675.png";